import React, { Component } from 'react';
import { NavMenu } from './NavMenu';

export class LayoutHome extends Component {
  static displayName = LayoutHome.name;

  render () {
    return (
        <div>
            <NavMenu />
            <div>
              {this.props.children}
            </div>
        </div>
    );
  }
}
